export enum EstateTaxFilingStatusKey {
  NEW_FILE = 'new_file',
  IN_PROGRESS = 'in_progress',
  HOLD_WAITING_FOR_PROBATE = 'hold_waiting_for_probate',
  HOLD_WAITING_FOR_EIN = 'hold_waiting_for_ein',
  HOLD_WAITING_FOR_IRS = 'hold_waiting_for_irs',
  BELOW_FILING_THRESHOLD = 'below_filing_threshold',
  HOLD_PROBATE_REQUIRED = 'hold_probate_required',
  HOLD_MISSING_PY_RETURNS = 'hold_missing_py_returns',
  HOLD_WAITING_FOR_T1_DOCS = 'hold_waiting_for_t1_docs',
  HOLD_WAITING_FOR_T3_DOCS = 'hold_waiting_for_t3_docs',
  CLOSED_FILING_PBC = 'closed_filing_pbc',
  CLOSED_CLIENT_SELF_FILING = 'closed_client_self_filing',
  CLOSED_CHURNED_EARLY_CLOSURE = 'closed_churned_early_closure',
  NOT_REQUIRED = 'not_required',
  PLANNING_CLIENT = 'planning_client',
  CLOSED_COMPLETED = 'closed_completed'
}
